import { LOCALE_STATUS } from '../../constants';
export const getLocales = (state) => state.locales ?? [];
export const getLocaleByLanguage = (state, language) => getLocales(state).find((locale) => locale?.id === language);
export const getDefaultSiteLocale = (state) => getLocales(state).find((locale) => locale?.status === LOCALE_STATUS.DEFAULT);
//# sourceMappingURL=selectors.js.map